import { render, staticRenderFns } from "./InclusiveNodeConfig.vue?vue&type=template&id=77b1b24a&scoped=true"
import script from "./InclusiveNodeConfig.vue?vue&type=script&lang=js"
export * from "./InclusiveNodeConfig.vue?vue&type=script&lang=js"
import style0 from "./InclusiveNodeConfig.vue?vue&type=style&index=0&id=77b1b24a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b1b24a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77b1b24a')) {
      api.createRecord('77b1b24a', component.options)
    } else {
      api.reload('77b1b24a', component.options)
    }
    module.hot.accept("./InclusiveNodeConfig.vue?vue&type=template&id=77b1b24a&scoped=true", function () {
      api.rerender('77b1b24a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/process/config/InclusiveNodeConfig.vue"
export default component.exports